import {
  SET_CATEGORY,
  FETCH_CATEGORY_PENDING,
  FETCH_CATEGORY_FULFILLED,
  FETCH_CATEGORY_REJECTED,
  FETCH_CATEGORY_BY_SLUG_PENDING,
  FETCH_CATEGORY_BY_SLUG_FULFILLED,
  FETCH_CATEGORY_BY_SLUG_REJECTED
} from "../actions/category";

const initialState = {
  fetching: false,
  categories: [],
  category: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORY:
      return {
        ...state,
        category: action.payload
      };
    case FETCH_CATEGORY_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_CATEGORY_FULFILLED:
      return {
        ...state,
        fetching: false,
        categories: action.payload
      };
    case FETCH_CATEGORY_REJECTED:
      return {
        ...state,
        fetching: true
      };

    case FETCH_CATEGORY_BY_SLUG_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_CATEGORY_BY_SLUG_FULFILLED:
      return {
        ...state,
        fetching: false,
        category: action.payload
      };
    case FETCH_CATEGORY_BY_SLUG_REJECTED:
      return {
        ...state,
        fetching: true
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/categoryReducer.js